// extracted by mini-css-extract-plugin
export default {"uploadIcon":"AddNewDocumentModal_uploadIcon__TnYPU","space":"AddNewDocumentModal_space__guNrv"};